import React from "react";
import { compose } from "redux";
import classNames from "classnames";
import { withStyles } from "@material-ui/styles";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { Grid, Button, Typography } from "@material-ui/core";

import DropdownMenu from "app/components/DropdownMenu";

const FilterDropdownMenu = ({
  title,
  label,
  value,
  classes,
  multiple,
  defaultText,
  ButtonProps,
  DropdownMenuProps,
  children,
  fullWidth,
}) => {
  return (
    <DropdownMenu
      multiple={multiple}
      Trigger={
        <Button
          size="small"
          color="default"
          className={classNames(classes.filterButton, {
            [classes.fullWidth]: fullWidth,
          })}
          {...ButtonProps}
        >
          <Grid
            container
            spacing={1}
            wrap="nowrap"
            alignItems="center"
            justifyContent="space-between"
          >
            <Grid
              item
              style={{
                overflow: "hidden",
              }}
            >
              <Typography
                noWrap
                align="left"
                title={title}
                display="block"
                variant="caption"
                className={classes.filterLabel}
              >
                {label || title}
              </Typography>
              <Typography
                noWrap
                align="left"
                display="block"
                variant="inherit"
                title={value || defaultText}
              >
                {value}
              </Typography>
            </Grid>
            <Grid
              item
              style={{
                display: "flex",
              }}
            >
              <ExpandMore />
            </Grid>
          </Grid>
        </Button>
      }
      {...DropdownMenuProps}
    >
      {children}
    </DropdownMenu>
  );
};

const styles = theme => ({
  filterButton: {
    maxWidth: 175,
    minWidth: 175,
    textTransform: "none",
    padding: `0 ${theme.spacing(1)}px`,
    background: theme.palette.common.white,
    "&:hover": {
      background: theme.palette.common.white,
    },
    boxShadow: theme.shadows[1],
  },
  filterLabel: {
    color: theme.palette.text.secondary,
  },
  fullWidth: {
    width: "100%",
  },
});

export default compose(React.memo, withStyles(styles))(FilterDropdownMenu);
